<!-- Application -->
<template>
    <header class="demo-header">
        <div id="title-container">
            <a
                id="title"
                :href="link"
            >
                <h1>{{ title }}</h1>
            </a>
        </div>
        <slot />
        <div id="tools">
            <bryntum-button
                text="Download Trial"
                href="https://bryntum.com/download/?product=schedulerpro"
                cls="b-green b-raised"
            />
            <bryntum-fullscreen-button />
        </div>
    </header>
</template>

<script>

import BryntumFullscreenButton from './BryntumFullscreenButton.vue';
import BryntumButton from './BryntumButton.vue';

export default {

    name : 'BryntumDemoHeader',

    components : {
        BryntumFullscreenButton,
        BryntumButton
    },

    computed : {
        link() {
            // Convert:
            // https://bryntum.com/products/schedulerpro/examples-scheduler/frameworks/vue-3/javascript/basic/build/
            // https://bryntum.com/products/schedulerpro/examples/frameworks/vue-3/javascript/basic/build/
            // To:
            // https://bryntum.com/products/schedulerpro/examples/#example-examples-scheduler-frameworks-vue-3-basic
            // https://bryntum.com/products/schedulerpro/examples/#example-frameworks-vue-3-basic

            const match = /(.*?\/)(examples.*?\/frameworks\/.*?)\/dist/.exec(document.location.href);
            return match ? `${match[1]}examples/#example-${match[2].replace(/\//gm, '-').replace('examples-frameworks', 'frameworks')}` : '#';
        }
    },

    props : {
        title : { type : String, default : document.title.split(' - ')[1] || document.title }
    }

};

</script>
